import React, { useEffect, useState } from "react";
import { Tab, Tabs, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  AutoStories,
  Event,
  ForumOutlined,
  Home,
  Storefront,
} from "@mui/icons-material";
import ArtistFab from "./ArtistFab";
import NotebookIcon from "@/fragments/NotebookIcon";
import { useParams } from "react-router-dom";
import { useArtist } from "@/services/hooks";

export default function SideTabs() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const { artistKey } = useParams();
  const { data: artist } = useArtist(artistKey);

  const handleTabChange = (e, newValue) => {
    switch (newValue) {
      case 0:
        navigate(`/${artistKey}`);
        break;
      case 1:
        navigate(`/${artistKey}/notes`);
        break;
      case 2:
        navigate(`/${artistKey}/music`);
        break;
      case 3:
        navigate(`/${artistKey}/store`);
        break;
      case 4:
        navigate(`/${artistKey}/threads`);
        break;
    }
  };

  useEffect(() => {
    if (window.location.pathname === `/${artistKey}`) {
      setActiveTab(0);
    } else if (window.location.pathname === `/${artistKey}/notes`) {
      setActiveTab(1);
    } else if (window.location.pathname === `/${artistKey}/music`) {
      setActiveTab(2);
    } else if (window.location.pathname === `/${artistKey}/store`) {
      setActiveTab(3);
    } else if (window.location.pathname === `/${artistKey}/threads`) {
      setActiveTab(4);
    }
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  return (
    <Box sx={{ display: { xs: "none", lg: "block" } }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        orientation="vertical"
        variant="fullWidth"
        slotProps={{
          indicator: {
            sx: { left: 0 },
          },
        }}
        sx={{
          position: "fixed",
          left: 20,
          top: "20%",
          bgcolor: "rgba(18, 18, 18, 0.95)",
          width: "140px",
          "& .MuiTab-root": {
            minHeight: "70px",
            width: "100%",
            padding: "15px",
            justifyContent: "flex-start",
            gap: 1,
          },
        }}
      >
        <Tab icon={<Home />} label="Home" iconPosition="start" />
        <Tab icon={<AutoStories />} label="Notes" iconPosition="start" />
        <Tab
          icon={
            <Box sx={{ display: "flex", alignItems: "center", pr: 0.3 }}>
              <NotebookIcon size={24} />
            </Box>
          }
          label="Music"
          iconPosition="start"
        />
        <Tab icon={<Event />} label="IRL" iconPosition="start" />
        {artist && artist?.meta?.community != "Off" && (
          <Tab
            icon={<ForumOutlined />}
            label="Community"
            iconPosition="start"
          />
        )}
      </Tabs>
      <ArtistFab />
    </Box>
  );
}
